import styled from 'styled-components'
import { mobileFirstMedia as media } from 'utils/media'

export const CategoryContainer = styled.section`
  position: relative;
`

export const CategoryTitle = styled.h3`
  background-color: ${p => p.theme.colors.bgSecondary};
  font-size: 20px;
  font-weight: 500;
  padding: 30px 15px 30px;

  ${media.screen`
    background-color: none;
  `}
`

export const MenuListContainer = styled.ul`
  background-color: ${props => props.theme.colors.white};
`
